module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAPCAYAAAAGRPQsAAAACXBIWXMAAAsTAAALEwEAmpwYAAABLElEQVQ4ja3Uv0vVURzG8df5ErgEDi4NgtDadg4NzUF/wBXBucAfk+IiFChSETgkqBg4ieISEU6uCjZE8IGWINAlcO8/6Otwj3AHu17xPnCWD8/zhufDOSe1bauUsoSCBq3Blar/Z0Ssp5zzBhbvAPifdhoc4+yeoO84Sm3bbVVKmcQantwBco61iDiElHPexEVEbFboS7zHoz6Qv3gTEZ9qZg7jKef8A091q65GxEk1vMYKRnog//AuIlar5xne4jlOU875M6Z6AqeYj4jfNfARcziIiNk6m8AuXvTk9lLO+Qsmb6jyFQsRcXk9KKWMYRvTN/j3H/TZSwedUsoutvDKLVeoH+xaM/XcqmYQ06BqdJ/EMJQajA4J9rDBtyHBfqX6ayzj8T1Af/DhCrLnU2J4tJL1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/aboutUs/contactUs/email.png
// module id = MPvY
// module chunks = 1